<template>
  <div class="flex items-center justify-center">
    <swiper :pagination="{ clickable: true }" loop :autoplay="{ delay: 30000 }" class="w-full h-full">
      <swiper-slide class="disclaimer">
        <div class="absolute inset-0">
          <img src="images/ROOF_TOP_BUILDING_FINAL.jpg" srcset="images/ROOF_TOP_BUILDING_FINAL.jpg 1440w, images/ROOF_TOP_BUILDING_FINAL@2x.jpg 3440w" class="object-cover w-full h-full" alt="">
        </div>
      </swiper-slide>
      <swiper-slide class="flex disclaimer">
        <div v-bg-image="'images/escent-01.jpg'" class="flex-1 bg-cover" />
        <div v-bg-image="'images/josefin-WS5yjFjycNY-unsplash-lightgreen.jpg'" class="flex-shrink-0 w-2/5 px-12 py-20 space-y-8 text-white bg-cover xl:px-16 xl:py-24 xl:w-1/3 2xl:w-1/4">
          <h1 class="mb-16 text-3xl font-bold uppercase xl:text-4xl xl:mb-32">
            A BETTER LIVING FOR ALL
          </h1>

          <p class="text-xl font-bold">
            อีกครั้ง กับชีวิตที่ดียิ่งกว่า...
          </p>

          <p class="">
            เอสเซ็นท์ ระยอง 2 คอนโดมิเนียม 23 ชั้น
            ติดศูนย์การค้า เซ็นทรัล ระยอง
            ด้วยประสบการณ์ใหม่กับการอยู่อาศัยแนวสูง
            Facility ครบครันในทุกส่วนของโครงการ
          </p>

          <p class="">
            สร้างความสุข ให้ทุกความสะดวกสบาย
            มาอยู่ใกล้ ได้มากกว่าเคย
          </p>
        </div>
      </swiper-slide>

      <swiper-slide class="grid grid-cols-2 grid-rows-2 disclaimer">
        <div class="relative row-span-full">
          <img src="images/Stocksy_2056564.jpg" srcset="images/Stocksy_2056564.jpg 1440w, images/Stocksy_2056564@2x.jpg 3440w" alt="" class="absolute inset-0 object-cover w-full h-full">
        </div>
        <div class="relative overflow-hidden">
          <img src="images/shutterstock_1830661397.jpg" srcset="images/shutterstock_1830661397.jpg 1440w, images/shutterstock_1830661397@2x.jpg 3440w" alt="" class="absolute inset-0 object-cover w-full h-full origin-top-right transform scale-110">
        </div>
        <div v-bg-image="'images/josefin-WS5yjFjycNY-unsplash-lightgreen.jpg'" class="grid p-12 text-center text-white bg-cover xl:p-16 place-items-center">
          <div class="max-w-md space-y-4 xl:space-y-8 place-items-center">
            <h1 class="text-xl font-bold uppercase xl:text-3xl">
              JOURNEY BACK HOME,<br>
              TO THE PLACE YOU BELONG
            </h1>
            <h2 class="text-lg font-bold xl:text-2xl">
              ให้ทุกวันดีๆ เกิดขึ้นได้ที่นี่...
            </h2>
            <p class="text-sm xl:text-base">
              ด้วยแนวคิด Journey Back Home
              ที่ต้องการให้คุณรู้สึกได้ถึงการกลับบ้านที่แท้จริง
              เพียงก้าวข้ามสู่โครงการ ที่รายล้อมด้วยต้นไม้
              สร้างความรู้สึกเป็นส่วนตัว สงบ
              ให้ความรู้สึกถึงการพักผ่อนในทุกช่วงเวลา
            </p>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import SwiperCore, { Pagination, Autoplay, Lazy } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'

SwiperCore.use([
  Pagination,
  Autoplay,
  Lazy,
])

export default {
  name: 'ProjectConcept',
  components: {
    Swiper,
    SwiperSlide,
  },
}
</script>
